import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Layout from "../../Layout/Layout";
import GetSvgIcon, {
  GetSvgBuilding,
  GetSvgLocationfill,
  GetSvgPerson,
  GetSvgPhone,
} from "../../../images/svglist";
import CustomerOrderBillingDetails from "../../OrderManagement/CustomerOrderBillingDetails";
import { CallApiGet } from "../../Helper/serviceApi";
import { DownloadFile } from "../../Helper/FileStoreService";
import { useSearchParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import {
  CH_SRVC_TYPE,
  INFO_CODE,
} from "../../../ConfigConstants/ConfigConstants";
import { API_URI } from "../../../ConfigConstants/UrlConstants";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};

const initObj = {
  orderType: 0,
  bookedOn: "",
  shipmentDate: "",
  origin: "",
  originSbu: "",
  destSbu: "",
  destination: "",
  senderAddress: "",
  recipientAddress: "",
  valueAddedService: "",
  custname: "",
  attachments: [
    {
      fileName: "",
      docBase64: null,
      description: "",
      attachmentId: 0,
    },
  ],
  shipmentbilling: [
    {
      billId: 0,
      billNo: "",
      billDate: "",
      billDtlId: 0,
      invoiceId: null,
      taxAmount: 0,
      billAmount: 0,
      customerId: 0,
      particular: "",
      totalTaxAmount: 0,
      totalBillAmount: 0,
    },
  ],
};

const CharteredOrderDetails = () => {
  const [spinner, setSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [chartOrdDtls, setChartOrdDtls] = useState(
    JSON.parse(JSON.stringify(initObj))
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [shipId, setShipId] = useState([]);
  const [bills, setBills] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [stops, setStops] = useState([]);
  const [rateData, setRateData] = useState([]);
  const [orderInfo, setOrderInfo] = useState([]);
  const [spclPremInfo, setSpclPremInfo] = useState([]);

  useEffect(() => {
    const orderId = searchParams.get("data");
    setShipId(orderId);
    getOrdDtls("orders", { orderId: orderId });
  }, []);

  const getOrdDtls = async (type, argData) => {
    setSpinner(true);
    let data = await CallApiGet(
      API_URI.GET_CH_ORD_DTLS + "?ordId=" + argData.orderId
    );
    if (data.respCode === 200) {
      let ordDetails = data.respData[0];
      ordDetails.insurance = !!ordDetails?.insurance
        ? JSON.parse(ordDetails?.insurance)
        : [];
      setChartOrdDtls(ordDetails);
      setBills(
        !!data?.respData[0]?.billing_data &&
          handelBillingDetails(JSON.parse(data?.respData[0]?.billing_data))
      );

      setStops(
        !!data?.respData[0]?.stops_data &&
          JSON.parse(data?.respData[0]?.stops_data)
      );
      let attachmentData =
        !!data?.respData[0]?.attachment_data &&
        JSON.parse(data?.respData[0]?.attachment_data);

      const groupByAttGroup = attachmentData
        ? attachmentData.reduce((attchMap, attch) => {
            if (!!attch.att_id) {
              if (!attchMap[attch.attachment_group]) {
                attchMap[attch.attachment_group] = [];
              }
              attchMap[attch.attachment_group].push(attch);
            }

            return attchMap;
          }, {})
        : [];

      const attachArr = Object.keys(groupByAttGroup).map((attGroup) => ({
        attGroup,
        attchObj: groupByAttGroup[attGroup],
      }));
      setAttachments([...attachArr]);
      setRateData(
        !!data?.respData[0]?.rate_data
          ? JSON.parse(data?.respData[0]?.rate_data)
          : []
      );
      const ordInfo = !!data?.respData[0]?.order_info
        ? JSON.parse(data?.respData[0]?.order_info)
        : [];
      setOrderInfo(ordInfo);
      setSpclPremInfo(
        ordInfo.filter((oi) => oi.infoCode === INFO_CODE.SPCLPERM)
      );
      setSpinner(false);
    } else {
      console.error();
      setSpinner(false);
    }
  };

  const handelBillingDetails = (data) => {
    let bill;
    if (data[0].particularId > 0) {
      const baseCharge = data
        .filter((a) => a.particularId === 215)
        .map((a) => a.billAmount)
        .reduce((a, b) => a + b, 0);
      // const bill1 = data.filter((a) =>
      //   [236, 237, 238, 239, 240, 241].includes(a.particularId)
      // )[0];
      let bill1 = {};

      const bill2 = data
        .filter((a) => [236, 237, 238, 239, 240, 241].includes(a.particularId))
        .map((a) => a.billAmount)
        .reduce((a, b) => a + b, 0);

      bill1.billNo = data[0].billNo;
      bill1.billDate = data[0].billDate;
      bill1.billId = data[0].billId;
      bill1.totalBillAmount = data[0].totalBillAmount;
      bill1.totalTaxAmount = data[0].totalTaxAmount;
      bill1.billAmount = bill2 + baseCharge;
      bill1.particular = "Shipment Charge";

      bill = data.filter(
        (a) => ![236, 237, 238, 239, 240, 241, 215].includes(a.particularId)
      );
      bill.push(bill1);
    } else {
      bill = data;
    }

    return bill;
  };

  const hideAlert = () => {
    setAlertConfig({
      isSuccess: alertConfig.isSuccess,
      size: alertConfig.size,
      show: false,
      title: "",
      description: "",
    });
  };
  const openAlert = (isSuccess, title, msg) => {
    setAlertConfig({
      isSuccess: isSuccess,
      size: "",
      show: true,
      title: title,
      description: msg,
    });
  };

  const onSuccess = (title, body) => {
    console.log("title", title, "body", body);
  };

  const onError = (errMsg) => {
    console.log("errMsg", errMsg);
  };

  const stopsView = () => {
    let stopBoxes = [];
    for (let i = 0; i < stops.length; i++) {
      let stopData = stops[i];
      let stopName = "Origin";
      if (stopData?.stop_seq === 99) stopName = "Destination";
      else if (stopData?.stop_seq > 0) stopName = `Stop ${stopData?.stop_seq}`;

      // Push each stop into stopBoxes as a column element
      stopBoxes.push(
        <div className="col-md-6 mb-2" key={i}>
          <div className="grd-bg p-3 rounded-3">
            <div className="fw-bold mb-1">{stopName}</div>
            <div className="theme-blue-txt">
              {stopData?.stop_cust_name && (
                <div className="d-flex align-items-center mb-1">
                  <span className="d-flex align-items-center theme-blue-txt me-2">
                    {GetSvgPerson(false)}
                  </span>
                  <div className="font-14">{stopData.stop_cust_name}</div>
                </div>
              )}
              {stopData?.stop_cust_phone && (
                <div className="d-flex align-items-center mb-1">
                  <span className="d-flex align-items-center theme-blue-txt me-2">
                    {GetSvgPhone(false)}
                  </span>
                  <div className="font-14">{stopData.stop_cust_phone}</div>
                </div>
              )}
              {(stopData?.stop_address ||
                stopData?.stop_city ||
                stopData?.stop_state ||
                stopData?.stop_postcode) && (
                <div className="d-flex align-items-start mb-1">
                  <span className="theme-blue-txt me-2 mt-1 d-flex align-items-start">
                    {GetSvgBuilding(false)}
                  </span>
                  <div className="font-14 d-flex align-items-start">
                    {[
                      stopData?.stop_address,
                      stopData?.stop_city,
                      stopData?.stop_state,
                      stopData?.stop_postcode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </div>
                </div>
              )}
              {(stopData?.stop_lat || stopData?.stop_long) && (
                <div className="d-flex align-items-center">
                  <span className="d-flex align-items-center theme-blue-txt me-2">
                    {GetSvgLocationfill()}
                  </span>
                  <div className="font-14 d-flex gap-3">
                    <span>Latitude: {stopData?.stop_lat || "-"}</span>
                    <span>Longitude: {stopData?.stop_long || "-"}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    // Group every two stopBoxes into a row
    const rows = [];
    for (let i = 0; i < stopBoxes.length; i += 2) {
      rows.push(
        <div className="row w-100" key={`row-${i}`}>
          {stopBoxes[i]}
          {stopBoxes[i + 1]}
        </div>
      );
    }

    // Return the grouped rows
    return <>{rows}</>;
  };

  const RenderAttch = ({ attachments, DownloadFile }) => {
    return (
      <Row className="mx-2">
        {!!attachments &&
          attachments.length > 0 &&
          attachments?.map((a, i) => (
            <Col md={6} className="grd-bg p-2 my-2 rounded-3 mb-1 mt-3">
              <>
                <span className="fw-bold">{a.attGroup}</span>
                {!!a.attchObj &&
                  a.attchObj
                    .sort((obj1, obj2) =>
                      obj1.att_name.localeCompare(obj2.att_name)
                    )
                    .map((o, i) => (
                      <div className="theme-blue-txt d-flex align-items-center justify-content-between">
                        <span className="fw-bold me-2">{o.att_name}</span>
                        <span className="theme-blue-txt me-2">{o.att_url}</span>
                        <button
                          type="button"
                          className="btn btn-outline theme-blue-txt bi bi-download ms-2"
                          onClick={() =>
                            DownloadFile(o.att_url, onSuccess, onError)
                          }
                        >
                          {GetSvgIcon("IconFiledownload")}
                        </button>
                      </div>
                    ))}
              </>
            </Col>
          ))}
      </Row>
    );
  };
  const attachmentView = () => {
    let attBoxes = [];
    let rowBoxes = [];

    for (let i in attachments) {
      let attData = attachments[i];
      let stopName = "Origin";
      if (+i === 99) stopName = "Destination";
      else if (+i > 0) stopName = `Stop${i}`;

      rowBoxes.push(
        <div className="col-md-6 p-2">
          <div className="grd-bg p-2 my-2 rounded-3">
            <div>
              <div className="fw-bold">{stopName}</div>
              <div className="theme-blue-txt d-flex align-items-center justify-content-between">
                <span className="theme-blue-txt me-2">
                  {attData["DO"].att_name}
                </span>
                <span className="me-auto">{attData["DO"].att_url}</span>
                <button
                  type="button"
                  className="btn btn-outline bi bi-download ms-2"
                  onClick={() =>
                    DownloadFile(attData["DO"].att_url, onSuccess, onError)
                  }
                >
                  {GetSvgIcon("IconFiledownload")}
                </button>
              </div>

              {+i === 0 && (
                <div className="theme-blue-txt d-flex align-items-center justify-content-between mt-1">
                  <span className="theme-blue-txt me-2">
                    {attData["POP"].att_name}
                  </span>
                  <span className="me-auto">{attData["POP"].att_url}</span>
                  <button
                    type="button"
                    className="btn btn-outline bi bi-download ms-2"
                    onClick={() =>
                      DownloadFile(attData["POP"].att_url, onSuccess, onError)
                    }
                  >
                    {GetSvgIcon("IconFiledownload")}
                  </button>
                </div>
              )}

              {+i > 0 &&
                attData["POD"].map((pod, index) => (
                  <div
                    key={index}
                    className="theme-blue-txt d-flex align-items-center justify-content-between mt-1"
                  >
                    <span className="theme-blue-txt me-2">{pod.att_name}</span>
                    <span className="me-auto">{pod.att_url}</span>
                    <button
                      type="button"
                      className="btn btn-outline bi bi-download ms-2"
                      onClick={() =>
                        DownloadFile(pod.att_url, onSuccess, onError)
                      }
                    >
                      {GetSvgIcon("IconFiledownload")}
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      );

      // Add the row to the attBoxes array and reset rowBoxes if we have two columns
      if ((+i + 1) % 2 === 0 || +i === attachments.length - 1) {
        attBoxes.push(<div className="row">{rowBoxes}</div>);
        rowBoxes = [];
      }
    }

    return attBoxes;
  };

  const generateBillBtn = async () => {
    setSpinner(true);
    let data = await CallApiGet(
      "CreateSchCharteredBill/" + chartOrdDtls?.planId
    );
    if (data.respCode === 200 || data.respCode === 0) {
      window.location.reload();
    } else {
      handleApiResponse();
    }
    setSpinner(false);
  };

  const handleApiResponse = () => {
    openAlert(
      false,
      "ERROR",
      "Something went wrong. Please try after sometime!!"
    );
  };

  const renderRateDetails = (rateData) => {
    return rateData?.map((item, index) => {
      let label = item.serviceType;
      let value = "";

      switch (item.serviceId) {
        case CH_SRVC_TYPE.WEIGHT:
        case CH_SRVC_TYPE.EXTRAMANPOWER:
          value = item.serviceValue;
          break;
        case CH_SRVC_TYPE.PIECES:
          label = item.unitTypeText;
          value = item.serviceValue;
          break;
        case CH_SRVC_TYPE.TAILGATE:
          value = "Yes";
          break;
        case CH_SRVC_TYPE.OTHERCHRG:
          label = item.rateRefName;
          value = "Yes";
          break;
        case CH_SRVC_TYPE.VHCLTYPE:
          value = item.rateRefName;
          break;
        default:
          return null;
      }

      return (
        <div className="col-md-3 col-sm-6 col-12" key={index}>
          <div className="grd-bg p-2 my-2 rounded-3">
            <div className="fw-bold">{label}</div>
            <div className="theme-blue-txt">{value}</div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
      >
        <div className="row mt-3">
          <div className="col-xxl-8 col-lg-9 col-md-12">
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Chartered Order Details
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Order Number</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.order_no}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Booking Date</div>
                    <div className="theme-blue-txt">
                      {/* {moment(chartOrdDtls?.booked_on).format(
                        DATE_TIME_FORMAT_MOMENT
                      )} */}
                      {chartOrdDtls?.booked_on}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Pickup Date</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.shipment_date}{" "}
                      {String(chartOrdDtls?.shipment_time).slice(0, 5)}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Estimated Delivery Date</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.est_delivery}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-item-center">
                  {/* Weight has been added to service section */}
                  {/* {chartOrdDtls?.rate_type === 766 && (
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Weight</div>
                      <div className="theme-blue-txt">
                        {chartOrdDtls?.order_weight} KG
                      </div>
                    </div>
                  )} */}
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Status</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.order_status}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Remarks</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.remarks}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Actual Delivery Time</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.actual_dlv_time}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Customer Details
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Customer Name</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.cust_name}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Company Name</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.business_name}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Account Number</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.acct_code}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Phone</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.cust_phone}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Email</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.cust_email}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Address</div>
                    <div className="theme-blue-txt">
                      {chartOrdDtls?.cust_addr +
                        ", " +
                        chartOrdDtls?.cust_city +
                        ", " +
                        chartOrdDtls?.cust_state +
                        ", Postcode - " +
                        chartOrdDtls?.post_code}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Services
              </div>
              <div className="p-2">
                <div className="row">{renderRateDetails(rateData)}</div>
              </div>
            </div>
            {!!chartOrdDtls?.insurancePkgId > 0 && (
              <div className="bg-white border border-2 rounded-2 mb-3">
                <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                  Protection Info
                </div>
                <div className="p-2">
                  <div className="d-flex justify-content-between align-item-center">
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Package Id</div>
                      <div className="theme-blue-txt">
                        {chartOrdDtls?.insurance !== null
                          ? chartOrdDtls?.insurance.packageId
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Coverage Upto</div>
                      <div className="theme-blue-txt">
                        {chartOrdDtls?.insurance !== null
                          ? "RM " + chartOrdDtls?.insurance.coverage
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Insurance Fee</div>
                      <div className="theme-blue-txt">
                        {chartOrdDtls?.insurance !== null
                          ? "RM " + chartOrdDtls?.insurance.charge
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Insurance Declared Price</div>
                      <div className="theme-blue-txt">
                        {!!chartOrdDtls?.insurance?.insDeclaredPrice &&
                        chartOrdDtls?.insurance?.insDeclaredPrice !== "null"
                          ? "RM " + chartOrdDtls?.insurance?.insDeclaredPrice
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Item Description
              </div>
              <div className="p-2">
                <div className="col grd-bg rounded-3 p-2 my-2">
                  <div className="row ps-1">
                    <div className="col px-2">
                      <div className="fw-bold">Item Name</div>
                    </div>
                    <div className="col px-2">
                      <div className="fw-bold">Item Type</div>
                    </div>
                    <div className="col-md-2 px-2">
                      <div className="fw-bold">Item Quantity</div>
                    </div>
                  </div>

                  {orderInfo
                    .filter((info) => info.infoCode === INFO_CODE.CH)
                    .map((item, index) => (
                      <div className="row ps-1" key={index}>
                        <div className="col ps-2">
                          <div className="theme-blue-txt">
                            {item?.infoValue}
                          </div>
                        </div>
                        <div className="col ps-2">
                          <div className="theme-blue-txt">{item?.infoType}</div>
                        </div>
                        <div className="col-md-2 ps-2">
                          <div className="theme-blue-txt">
                            {item?.infoQuantity}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Stops
              </div>
              {stopsView()}
            </div>
            {spclPremInfo?.length > 0 && (
              <div className="bg-white border border-2 rounded-2 mb-3">
                <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                  Special Permission Info
                </div>
                <div className="p-2">
                  <div className="d-flex justify-content-between align-item-center">
                    {spclPremInfo?.map((info) => (
                      <div className="col grd-bg p-2 p my-2 rounded-3">
                        <div className="fw-bold">
                          Special permission {info?.infoValue}
                        </div>
                        <div className="theme-blue-txt">YES</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {attachments.length > 0 && (
              <div className="bg-white border border-2 rounded-2 mb-3">
                <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                  Order Attachment
                </div>
                {/* {attachmentView()} */}
                <RenderAttch
                  attachments={attachments}
                  DownloadFile={DownloadFile}
                />
              </div>
            )}
          </div>
          <div className="col-xxl-4 col-lg-3 col-md-12">
            {bills.length > 0 && bills.some((bill) => !!bill.billId) ? (
              <CustomerOrderBillingDetails billingDetails={bills} />
            ) : (
              <>
                <div className="col grd-bg p-2 p my-2 rounded-3">
                  <span className="theme-violet-txt fw-bold ms-4">
                    The Bill is not yet generated!!!{" "}
                  </span>{" "}
                  {/* {chartOrdDtls?.statusId === 79 && (
                    <>
                      <div className="row">
                        <div className="col  text-end">
                          <Button
                            variant="outline-primary"
                            className="mt-2"
                            onClick={() => generateBillBtn()}
                          >
                            Generate Now
                          </Button>
                        </div>
                        <div className="col-md-4"></div>
                      </div>
                    </>
                  )}{" "} */}
                </div>
              </>
            )}

            {/* {bills.length > 0 && bills.some((bill) => !!bill.billId) && ( */}
            {/* <CustomerOrderBillingDetails billingDetails={bills} /> */}
            {/* )} */}
          </div>
        </div>
        <Header />
      </Layout>
    </>
  );
};

export default CharteredOrderDetails;
